"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImmutableDataCache = void 0;
const workbox_expiration_1 = require("workbox-expiration");
const DEFAULT_MAX_CACHE_OBJECT_SIZE_BYTES = 2 * 1024 * 1024; // 2MB
class ImmutableDataCache {
    constructor(cacheName, config = {}) {
        var _a;
        this._cacheName = cacheName;
        this._expirationManager = new workbox_expiration_1.CacheExpiration(cacheName, {
            maxAgeSeconds: config.maxAgeSeconds,
            maxEntries: config.maxEntries
        });
        this._maxObjectSize = (_a = config.maxObjectSizeBytes) !== null && _a !== void 0 ? _a : DEFAULT_MAX_CACHE_OBJECT_SIZE_BYTES;
    }
    tryGet(key) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const cache = yield this.openCache();
                if (!cache) {
                    return null;
                }
                const response = yield cache.match(key);
                if (!response) {
                    return null;
                }
                // We are doing this with the assumption that the cached objects are immutable
                yield this._expirationManager.updateTimestamp(key);
                return new Uint8Array(yield response.arrayBuffer());
            }
            catch (e) {
                console.log(e);
                return null;
            }
        });
    }
    put(key, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (data.length > this._maxObjectSize) {
                    return false;
                }
                const cache = yield this.openCache();
                if (!cache) {
                    return false;
                }
                yield cache.put(key, new Response(data));
                yield this._expirationManager.updateTimestamp(key);
                return true;
            }
            catch (e) {
                console.log(e);
                return false;
            }
        });
    }
    scavenge() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._expirationManager.expireEntries();
        });
    }
    openCache() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!("caches" in window)) {
                return null;
            }
            return (_a = yield caches.open(this._cacheName)) !== null && _a !== void 0 ? _a : null;
        });
    }
}
exports.ImmutableDataCache = ImmutableDataCache;
